/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FcaFuelSurchargeValues
 */
export interface FcaFuelSurchargeValues {
  /**
   *
   * @type {string}
   * @memberof FcaFuelSurchargeValues
   */
  fcaFuelSurchargeId?: string;
  /**
   *
   * @type {string}
   * @memberof FcaFuelSurchargeValues
   */
  fuelSurchargeIdentifier?: string;
  /**
   *
   * @type {number}
   * @memberof FcaFuelSurchargeValues
   */
  value?: number;
  /**
   *
   * @type {string}
   * @memberof FcaFuelSurchargeValues
   */
  notes?: string;
  /**
   *
   * @type {string}
   * @memberof FcaFuelSurchargeValues
   */
  createdBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof FcaFuelSurchargeValues
   */
  createdAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the FcaFuelSurchargeValues interface.
 */
export function instanceOfFcaFuelSurchargeValues(
  value: object,
): value is FcaFuelSurchargeValues {
  return true;
}

export function FcaFuelSurchargeValuesFromJSON(
  json: any,
): FcaFuelSurchargeValues {
  return FcaFuelSurchargeValuesFromJSONTyped(json, false);
}

export function FcaFuelSurchargeValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FcaFuelSurchargeValues {
  if (json == null) {
    return json;
  }
  return {
    fcaFuelSurchargeId:
      json["fcaFuelSurchargeId"] == null
        ? undefined
        : json["fcaFuelSurchargeId"],
    fuelSurchargeIdentifier:
      json["fuelSurchargeIdentifier"] == null
        ? undefined
        : json["fuelSurchargeIdentifier"],
    value: json["value"] == null ? undefined : json["value"],
    notes: json["notes"] == null ? undefined : json["notes"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
  };
}

export function FcaFuelSurchargeValuesToJSON(
  json: any,
): FcaFuelSurchargeValues {
  return FcaFuelSurchargeValuesToJSONTyped(json, false);
}

export function FcaFuelSurchargeValuesToJSONTyped(
  value?: FcaFuelSurchargeValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fcaFuelSurchargeId: value["fcaFuelSurchargeId"],
    fuelSurchargeIdentifier: value["fuelSurchargeIdentifier"],
    value: value["value"],
    notes: value["notes"],
    createdBy: value["createdBy"],
    createdAt: value["createdAt"],
  };
}
